// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_eWP","cls2":"PodcastLibraryCarouselAd-cls2_7hb PodcastLibraryCarouselAd-cls1_eWP"};